<template>
  <v-container class="container-wrapper">
    <div class="title py-5">Select Dashboard</div>
    <v-row class="justify-center align-self-baseline">
      <v-col cols="12" lg="3" md="6" sm="6" v-for="(item, index) in getRoles" :key="index">
       <dashboard-card :title="item.name" :code="item.code" :link="item.link"  :domain="item.domain"></dashboard-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// import moment from "moment";
// import ChangePasswordForm from "../../components/ChangePasswordForm.vue";
import DashboardCard from "./DashboardCard.vue";
export default {
  name: "SelectDashboard",
  components: {
    DashboardCard,
  },
  data() {
    return {
      colors: ["#c07bc3", "#a6dcaf", "#ddddce"],
      projects: [
        { name: "Learning laravel", desc: "Finish video asap", date: "28" },
        { name: "Learning laravel", desc: "Finish video asap", date: "28" },
        { name: "Learning laravel", desc: "Finish video asap", date: "28" },
        { name: "Learning laravel", desc: "Finish video asap", date: "28" },
        { name: "Learning laravel", desc: "Finish video asap", date: "28" },
        // { name: "Learning laravel", desc: "Finish video asap", date: "28" },
        // { name: "Learning laravel", desc: "Finish video asap", date: "28" },

        // { name: "Learning laravel", desc: "Finish video asap", date: "28" },
        // { name: "Learning laravel", desc: "Finish video asap", date: "28" },

        // { name: "Learning laravel", desc: "Finish video asap", date: "28" },
        // { name: "Learning laravel", desc: "Finish video asap", date: "28" },
        // { name: "Learning laravel", desc: "Finish video asap", date: "28" },
        // { name: "Learning laravel", desc: "Finish video asap", date: "28" },
        // { name: "Learning laravel", desc: "Finish video asap", date: "28" },
        // { name: "Learning laravel", desc: "Finish video asap", date: "28" },

        // { name: "Learning laravel", desc: "Finish video asap", date: "28" },
        // { name: "Learning laravel", desc: "Finish video asap", date: "28" },
      ],
    };
  },

  // props: ["dialog"],

  methods: {
    setColor() {
      return this.colors[Math.floor(Math.random() * this.colors.length)];
    },
  },

  computed: {
    getRoles() {
      const { adminLogin } = this.$store.getters.userData;

      var roles = adminLogin.roles.filter((role) => {
        if(role.dashboardName){

          return role;
        }

      });

      console.log('roles', roles)

      return roles;
    },
  },

  watch: {},
};
</script>

<style scoped>
.container-wrapper {
  display: grid;
  height: 100%;
}

.main-class {
  display: flex;
  align-items: center;
}

.main-class .title {
  text-align: center;
  font-size: 21px !important;
  margin-bottom: 14px;
  font-weight: 500;
}

.v-application .title {
  font-size: 2rem !important;
  font-weight: 500;
  line-height: 2rem;
  letter-spacing: 0.0125em !important;
  font-family: "Poppins", sans-serif !important;
  align-self: center;
  text-align: center;
}

.card-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;

}
</style>
